import React, { useEffect } from "react";
import { Handle } from "react-flow-renderer";
import { MdOutlinePeople } from "react-icons/md";

const CustomNode = ({ data, isConnectable }) => {
  const nodeType = (temp) => {
    switch (temp) {
      case 0:
        return "node-process-child";

      case 1:
        return "node-process-input persoCustomNodeColor";

      case 2:
        return "node-process-output persoCustomNodeColor";

      default:
        return "node-process-child";
    }
  };

  return (
    <>
      <div className={nodeType(data.template)}>
        <Handle
          style={{ width: 15, height: 15, left: -10 }}
          id="a"
          type="target"
          position="left"
        />
        <Handle
          id="b"
          style={{
            width: 15,
            height: 15,
            right: -10,
          }}
          type="source"
          position="right"
        />
        <div className="node-process-container">
          <div className="node-process-text">{data.process.nom}</div>
          {data.process.orgunits.length > 0 && (
            <div
              size="sm"
              className="no-interact"
              variant="light"
              style={{
                position: "absolute",
                bottom: 0,
                right: 20,
                borderRadius: 2,
                cursor: "pointer",
              }}
            >
              <MdOutlinePeople style={{ pointerEvents: "none" }} size={20} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomNode;
